<div class="household-info-panel">
  <div class="household-info-panel__grid">
    <div class="household-info-panel__household-info-column">
      <span class="household-info-panel__section-title" data-pw="household_contact_info_title" data-qa="household_contact_info_title">Contact Information</span>
      <div>
        <div class="household-info-panel__info-item">
          <span class="household-info-panel__label" data-pw="household_address_label" data-qa="household_address_label"> Address:</span>
        </div>
        <div class="household-info-panel__value">
          <span data-pw="household_address_value" data-qa="household_address_value" [innerHTML]="formattedAddress || '-'"></span>
        </div>
      </div>
      <div class="household-info-panel__info-item">
        <div>
          <span class="household-info-panel__label" data-pw="household_email_label" data-qa="household_email_label">County:</span>
        </div>
        <div class="household-info-panel__value">
          <span>{{ householdData.county ? householdData.county : '-' }}</span>
        </div>
      </div>
      <div class="household-info-panel__info-item">
        <div>
          <span class="household-info-panel__label" data-pw="household_email_label" data-qa="household_email_label">Email Address:</span>
        </div>
        <div class="household-info-panel__value">
          <span data-pw="household_email_value" data-qa="household_email_value">{{ householdData.email || '-' }}</span>
        </div>
      </div>
      <div class="household-info-panel__info-item">
        <div>
          <span class="household-info-panel__label" data-pw="household_phone_label" data-qa="household_phone_label">Phone:</span>
        </div>
        <div class="household-info-panel__value">
          <span data-pw="household_phone_value" data-qa="household_phone_value">{{ householdData.phoneNumber ? (householdData.phoneNumber | phone) : '-' }}</span>
        </div>
      </div>
    </div>
    <div class="household-info-panel__household-info-column">
      <span class="household-info-panel__section-title" data-pw="household_parent_info_title" data-qa="household_parent_info_title">Parent Information</span>
      <div>
        <div>
          <div class="household-info-panel__info-item">
            <div>
              <span class="household-info-panel__label" data-pw="household_parent_name_label" data-qa="household_parent_name_label">Parent Name:</span>
            </div>
            <div class="household-info-panel__value">
              <span data-pw="household_parent_name_value" data-qa="household_parent_name_value">
                {{ getFullName() }}
              </span>
            </div>
          </div>
          <div class="household-info-panel__info-item">
            <div>
              <span class="household-info-panel__label" data-pw="household_parent_dob_label" data-qa="household_parent_dob_label">Parent Birth Date:</span>
            </div>
            <div class="household-info-panel__value">
              <span data-pw="household_parent_dob_value" data-qa="household_parent_dob_value">
                {{
                   householdData.dob ? (householdData.dob.split('T')[0] | date: 'MM/dd/yyyy') : '-'
                }}
              </span>
            </div>
          </div>
          <div class="household-info-panel__info-item">
            <div>
              <span class="household-info-panel__label" data-pw="household_parent_ssn_label" data-qa="household_parent_ssn_label">Parent Social Security:</span>
            </div>
            <div class="household-info-panel__value">
              <span data-pw="household_parent_ssn_value" data-qa="household_parent_ssn_value">
                {{ householdData.ssn ? 'XXX-XX-' + getLastFourSsn(householdData.ssn): '-' }}
              </span>
            </div>
          </div>
          <div class="household-info-panel__info-item">
            <div>
              <span class="household-info-panel__label" data-pw="household_parent_dl_label" data-qa="household_parent_dl_label">North Carolina Driver's License Number:</span>
            </div>
            <div class="household-info-panel__value">
              <span data-pw="household_parent_dl_value" data-qa="household_parent_dl_value">{{ householdData.driversLicense || '-' }}</span>
            </div>
          </div>
          <div class="household-info-panel__info-item">
            <div>
              <span class="household-info-panel__label" data-pw="household_parent_issuing_state_label" data-qa="household_parent_issuing_state_label">Issuing State:</span>
            </div>
            <div class="household-info-panel__value">
              <span data-pw="household_parent_issuing_state_value" data-qa="household_parent_issuing_state_value">{{ householdData.issuingState === 'North Carolina' ? householdData.issuingState : '-' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="household-info-panel__household-info-column">
      <span class="household-info-panel__section-title" data-pw="household_info_title" data-qa="household_info_title">Household Information</span>
      <div>
        <div>
          <div class="household-info-panel__info-item">
            <div>
              <span class="household-info-panel__label" data-pw="household_income_label" data-qa="household_income_label">Disclosed Income:</span>
            </div>
            <div class="household-info-panel__value">
              <span data-pw="household_income_value" data-qa="household_income_value">
                {{ getDisclosedIncome() }}</span>
            </div>
          </div>
          <div class="household-info-panel__info-item">
            <div>
              <span class="household-info-panel__label" data-pw="household_verified_income_label" data-qa="household_verified_income_label">Verified Income:</span>
            </div>
            <div class="household-info-panel__value">
              <span data-pw="household_verified_income_value" data-qa="household_verified_income_value">{{
                getVerifiedIncome()
              }}</span>
            </div>
          </div>
          <div class="household-info-panel__info-item">
            <div>
              <span class="household-info-panel__label" data-pw="household_size_label" data-qa="household_size_label">Household Size:</span>
            </div>
            <div class="household-info-panel__value">
              <span data-pw="household_size_value" data-qa="household_size_value">{{ householdData.householdMemberCount || '-' }}</span>
            </div>
          </div>
          <div class="household-info-panel__info-item">
            <div>
              <span class="household-info-panel__label" data-pw="household_tier_label" data-qa="household_tier_label">Award Tier:</span>
            </div>
            <div class="household-info-panel__value">
              <span data-pw="household_tier_value" data-qa="household_tier_value">{{ householdData.householdTier || '-' }}</span>
            </div>
          </div>
          <div class="household-info-panel__info-item">
            <div>
              <span class="household-info-panel__label" data-pw="household_students_label" data-qa="household_students_label">No. of Students:</span>
            </div>
            <div class="household-info-panel__value">
              <span data-pw="household_students_value" data-qa="household_students_value">{{ householdData.students.length || 0 }}</span>
            </div>
          </div>
          <div class="household-info-panel__info-item">
            <div>
              <span class="household-info-panel__label" data-pw="household_disclose_income_label" data-qa="household_disclose_income_label">Disclose Income:</span>
            </div>
            <div class="household-info-panel__value">
              <span data-pw="household_disclose_income_value" data-qa="household_disclose_income_value">
                {{
                  householdData.disclosedInformation === true ? 'Yes'
                    : householdData.disclosedInformation === false ? 'No'
                    : '-'
                }}
              </span>
            </div>
          </div>
          @if (showIncomeVerification) {
            <div class="household-info-panel__info-item">
              <div>
                <span class="household-info-panel__label" data-pw="household_income_verification_label" data-qa="household_income_verification_label">Chosen for Income Verification:</span>
              </div>
              <div class="household-info-panel__value">
                <span data-pw="household_income_verification_value" data-qa="household_income_verification_value">
                  {{
                  householdData.incomeVerificationRequired ? 'Yes' : 'No'
                  }}
                </span>
              </div>
            </div>
          }
          <div class="household-info-panel__info-item">
            <div>
              <span class="household-info-panel__label" data-pw="household_nc_residency_label" data-qa="household_nc_residency_label">NC Residency:</span>
            </div>
            <div class="household-info-panel__value">
              <span data-pw="household_nc_residency_value" data-qa="household_nc_residency_value">
                {{
                  householdData.ncResidency === true ? 'Yes'
                    : householdData.ncResidency === false ? 'No'
                    : 'Not Evaluated'
                }}
              </span>
            </div>
          </div>
          <div class="household-info-panel__info-item">
            <div>
              <span class="household-info-panel__label" data-pw="household_nc_residency_verified_label" data-qa="household_nc_residency_verified_label">Residency Verified:</span>
            </div>
            <div class="household-info-panel__value">
              <span data-pw="household_nc_residency_verified_value" data-qa="household_nc_residency_verified_value">
                {{
                  householdData.ncResidencyVerified === true ? 'Yes'
                    : householdData.ncResidencyVerified === false ? 'No'
                    : 'Not Evaluated'
                }}
              </span>
            </div>
          </div>
          @if (showIncomeVerification && householdData.incomeVerificationRequired) {
            <div class="household-info-panel__info-item">
              <div>
                <span class="household-info-panel__label" data-pw="household_income_verification_reason_label" data-qa="household_income_verification_reason_label">Income Verification Reason:</span>
              </div>
              <div class="household-info-panel__value">
                <span data-pw="household_income_verification_reason_value" data-qa="household_income_verification_reason_value">
                  {{
                  householdData.incomeVerificationReason
                  }}
                </span>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
